import {
    ConsumeConfirmCodeProps,
    LoginProps as LoginMutationProps, RegenerateConfirmCodeProps,
    withConsumeConfirmCode,
    withLogin,
    withRegenerateConfirmCode
} from "@graphql2/types";
import { Login } from "@pages/login/login";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "redux";

export interface LoginContainerProps {
}

export const withLoginMutation = withLogin({
    name: "login"
});

export const withConsumeConfirmCodeMutation = withConsumeConfirmCode({
    name: "consumeConfirmCode"
});

export const withRegenerateConfirmCodeMutation = withRegenerateConfirmCode({
    name: "regenerateConfirmCode"
});

export const LoginContainer = compose<React.ComponentClass<LoginContainerProps>>(
    withLoginMutation,
    withConsumeConfirmCodeMutation,
    withRegenerateConfirmCodeMutation,
    withRouter
)(Login);

export type LoginProps =
    LoginContainerProps &
    RouteComponentProps &
    LoginMutationProps<{}, "login"> &
    ConsumeConfirmCodeProps<{}, "consumeConfirmCode"> &
    RegenerateConfirmCodeProps<{}, "regenerateConfirmCode">;
